function clipMenuToScreen() {
  // Allow homepage blocks to have the "hover" effect on mobile
  const dropdownitems = document.querySelectorAll('nav div div')
  const windowWidth = (window.innerWidth || document.documentElement.clientWidth)
  for (const item of dropdownitems) {
    const bounding = item.getBoundingClientRect()

    if (bounding.right >= windowWidth) {
      item.style.right = '0px'
    } else if (item.style.right) {
      const newRight = bounding.right + width;
      console.log(width, bounding.width, newRight <= windowWidth)

      if(newRight <= windowWidth) {
        item.style.right = null;
      }
    }

  }
}

window.addEventListener('DOMContentLoaded', clipMenuToScreen)
window.addEventListener('resize', clipMenuToScreen)